import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  width: "18.914",
  height: "18.914",
  viewBox: "0 0 18.914 18.914"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g id=\"but_table_enlarge\" transform=\"translate(1.414)\"><g id=\"Ellipse_173\" data-name=\"Ellipse 173\" transform=\"translate(2.5)\" fill=\"none\" stroke=\"#fff\" stroke-width=\"2\"><circle cx=\"7.5\" cy=\"7.5\" r=\"7.5\" stroke=\"none\"></circle><circle cx=\"7.5\" cy=\"7.5\" r=\"6.5\" fill=\"none\"></circle></g><line id=\"Line_146\" data-name=\"Line 146\" y1=\"5\" x2=\"5\" transform=\"translate(0 12.5)\" fill=\"none\" stroke=\"#fff\" stroke-linecap=\"round\" stroke-width=\"2\"></line><line id=\"Line_147\" data-name=\"Line 147\" x2=\"7\" transform=\"translate(6.5 7.5)\" fill=\"none\" stroke=\"#fff\" stroke-linecap=\"round\" stroke-width=\"2\"></line><line id=\"Line_148\" data-name=\"Line 148\" y1=\"7\" transform=\"translate(10 4)\" fill=\"none\" stroke=\"#fff\" stroke-linecap=\"round\" stroke-width=\"2\"></line></g>", 1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  width: "18.914",
  height: "18.914",
  viewBox: "0 0 18.914 18.914"
}
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<g id=\"but_table_zoomout\" transform=\"translate(1.414)\"><g id=\"Ellipse_173\" data-name=\"Ellipse 173\" transform=\"translate(2.5)\" fill=\"none\" stroke=\"#fff\" stroke-width=\"2\"><circle cx=\"7.5\" cy=\"7.5\" r=\"7.5\" stroke=\"none\"></circle><circle cx=\"7.5\" cy=\"7.5\" r=\"6.5\" fill=\"none\"></circle></g><line id=\"Line_146\" data-name=\"Line 146\" y1=\"5\" x2=\"5\" transform=\"translate(0 12.5)\" fill=\"none\" stroke=\"#fff\" stroke-linecap=\"round\" stroke-width=\"2\"></line><line id=\"Line_147\" data-name=\"Line 147\" x2=\"7\" transform=\"translate(6.5 7.5)\" fill=\"none\" stroke=\"#fff\" stroke-linecap=\"round\" stroke-width=\"2\"></line></g>", 1)
const _hoisted_6 = [
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isOn)
    ? (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
    : (_openBlock(), _createElementBlock("svg", _hoisted_4, _hoisted_6))
}